import { Helmet } from "react-helmet";
import React, { useState, Component } from "react";
import { Button, Form, FormControl, Dropdown, Table, Row, Col } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import "../../styles/notification/notification.scss";
import { encodeQueryData } from "../../api/apiClient";
import Search from "../commoncomponents/Search";
import Paginations from "../commoncomponents/pagination";
import ShowingResults from "../commoncomponents/showingResults";
import moment from "moment";
import { utcToLocal } from "../../utils/dateConvert";

const timeValueToUtcMoment = (value) => {
  const [hour, minute] = value.split(":").map(Number);
  return moment.utc().hour(hour).minute(minute).second(0).millisecond(0);
};

class EditNotification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      NotificationDetail: [],
      eventList: [],
      groupList: [],
      assetList: [],
      completeAssetList: [],
      userId: "",
      groupId: "",
      groupName: "Select group",
      groupCustomerName: "",
      userName: "Select user",
      customerID: "default",
      customerName: "",
      name: "",
      name_error: false,
      user_error: false,
      description: "",
      status: "1",
      pageCount: 0,

      //states for showing entries and total entries in page
      totalEntry: 0,
      entryStart: "0",
      entryEnd: "0",
      totalFilter: false,
      totalEntryFilter: "",
      filterMessage: false,

      // config
      mon: true,
      tue: true,
      wed: true,
      thu: true,
      fri: true,
      sat: true,
      sun: true,
      hours: 1,
      startPeriod: "",
      endPeriod: "",
      defaultStart: "",
      defaultEnd: "",
      email: false,
      sortString: "name",
      sortDirection: "asc",
      tempANotification: false,
      tempBNotification: false,
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
    this.checkedEvents = [];
    this.checkedAssets = [];
    this.formSubmit = false;
    this.searchText = "";
    this.groupId = "";
    this.pageSize = "10";
    this.pageKey = "1";
  }

  async componentDidMount() {
    this.props.setLoadingPageAction(true);

    console.log("params", this.props);
    try {
      const NotificationDetail = await axios.post(
        `${apiHost}/api/Notification/SelectNotification/${this.props.match.params.id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const config = JSON.parse(NotificationDetail.data.config);

      const detail = NotificationDetail.data;
      this.checkedEvents = Array.isArray(detail.events) ? [...detail.events] : [];
      this.checkedAssets = Array.isArray(detail.assets) ? [...detail.assets] : [];

      this.setState({
        NotificationDetail: detail,
        userId: detail.userId,
        userName: detail.userName,
        customerName: detail.customerName,
        name: detail.name,
        description: detail.description,
        tempANotification: detail.tempANotification,
        tempBNotification: detail.tempBNotification,
        hours: config.Hours,
        groupId: detail.groupid,
        status: detail.status,
        mon: config.Days.Monday,
        tue: config.Days.Tuesday,
        wed: config.Days.Wednesday,
        thu: config.Days.Thursday,
        fri: config.Days.Friday,
        sat: config.Days.Saturday,
        sun: config.Days.Sunday,
        email: config.Email,
        uniqueId: detail.uniqueId
      });

      this.handleActiveRadio(config.Hours);
      let startTimeHour = moment.utc(config.Period.Start).get("hour");
      let startTimeMinutes = moment.utc(config.Period.Start).get("minute");
      if (startTimeHour < 10) {
        startTimeHour = "0" + startTimeHour;
      }
      if (startTimeMinutes < 10) {
        startTimeMinutes = "0" + startTimeMinutes;
      }
      // let Start = this.tConvert(`${startTimeHour}:${startTimeMinutes}`);
      let endTimeHour = moment.utc(config.Period.End).get("hour");
      let endTimeMinutes = moment.utc(config.Period.End).get("minute");
      if (endTimeHour < 10) {
        endTimeHour = "0" + endTimeHour;
      }
      if (endTimeMinutes < 10) {
        endTimeMinutes = "0" + endTimeMinutes;
      }

      var ordStartTime = moment.utc().hour(8).minute(0);
      var ordEndTime = moment.utc().hour(17).minute(0);
      var startTime = moment.utc().hour(startTimeHour).minute(startTimeMinutes);
      var endTime = moment.utc().hour(endTimeHour).minute(endTimeMinutes);
      if (isNaN(startTimeHour || startTimeMinutes || endTimeHour || endTimeMinutes)) {
        const ordStartValue = ordStartTime.format("HH:mm");
        const ordEndValue = ordEndTime.format("HH:mm");
        this.setState({
          defaultStart: ordStartValue,
          defaultEnd: ordEndValue,
        });
        this.onStartTimeChange(ordStartValue);
        this.onEndTimeChange(ordEndValue);
      } else {
        const startValue = startTime.format("HH:mm");
        const endValue = endTime.format("HH:mm");
        this.setState({
          defaultStart: startValue,
          defaultEnd: endValue,
        });
        this.onStartTimeChange(startValue);
        this.onEndTimeChange(endValue);
      }

      let groupUrl = `${apiHost}/api/Notification/AllGroupForNotification?UserId=${detail.userId}`;

      await this.getGroups(groupUrl, detail.groupid);
      console.log("NotificationDetail ", NotificationDetail.data);
      console.log(
        "checked assets from component did mount",
        this.checkedAssets
      );

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    this.props.setLoadingPageAction(true);

    try {
      const eventList = await axios.get(
        `${apiHost}/api/Notification/AllEventsForNotification`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ eventList: eventList.data });
      console.log("eventList ", eventList.data);

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

  }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };

  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({ sortDirection: "des" });
      this.sortDirection = "des";
    } else {
      this.setState({ sortDirection: "asc" });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.handleSort(name, order);
  };

  handleSort = (name, order) => {
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setAssetsQueryObject());
    console.log("notification group query", query);
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    this.postAssets(urlAll);
  };
  getGroups = async (url, selectedGroupId = null) => {
    this.props.setLoadingPageAction(true);

    try {
      const groupList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ groupList: groupList.data });
      console.log("groupList ", groupList.data);
      const groupId = selectedGroupId || this.state.groupId;
      const selectedGroup = groupList.data.find((item) => item.groupId === groupId);
      if (selectedGroup) {
        await this.handleAutoGroupDropDown(
          selectedGroup.groupId,
          selectedGroup.groupName,
          selectedGroup.customername
        );
      }

      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleSubmit = async () => {
    this.formSubmit = 0;
    if (this.state.name == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
      this.formSubmit++;
    }
    if (this.state.userId == "") {
      this.setState({ user_error: true });
    } else {
      this.formSubmit++;
      this.setState({ user_error: false });
    }

    if (this.formSubmit == 2) {
      var uri_enc = encodeURIComponent(
        `{"Days":{"Friday":${this.state.fri},"Monday":${this.state.mon},"Sunday":${this.state.sun},"Tuesday":${this.state.tue},"Saturday":${this.state.sat},"Thursday":${this.state.thu},"Wednesday":${this.state.wed}},"Email":${this.state.email},"Hours":"${this.state.hours}","Period":{"End":"${this.state.endPeriod}","Start":"${this.state.startPeriod}"},"GroupID":"${this.state.groupId}"}`
      );

      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Notification/Update`,
          {
            Id: this.props.match.params.id,
            UserId: this.state.userId,
            Name: this.state.name,
            Description: this.state.description,
            config: uri_enc,
            status: this.state.status,
            GroupId: this.state.groupId,
            EventId: this.checkedEvents,
            AssetId: this.checkedAssets,
            dbUpdated: this.state.NotificationDetail.dbUpdated,
            dbCreated: this.state.NotificationDetail.dbCreated,
            TempANotification: this.state.tempANotification,
            TempBNotification: this.state.tempBNotification,
            UniqueId:this.state.uniqueId
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        this.props.history.goBack();
        console.log("notification ", response.data);

        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  };

  handleUserDropDown = (userId, userName, customerName) => {
    this.setState({
      userId: userId,
      userName: userName,
      customerName: customerName,
    });
    let groupUrl = `${apiHost}/api/Notification/AllGroupForNotification?UserId=${userId}`;
    this.getGroups(groupUrl);
    this.setState({
      groupId: "",
      groupName: "Select group",
      groupCustomerName: "",
      assetList: [],
    });
  };

  handleNameChange = (e) => {
    this.setState({ name_error: e.target.value == "" });
    this.setState({ name: e.target.value });
  };

  handleDescriptionChange = (e) => {
    console.log(e.target.value);
    this.setState({ description: e.target.value });
  };

  handleDayCheckBox = (e) => {
    let dayCheckbox = document.getElementsByClassName("day");

    for (var i in dayCheckbox) {
      switch (dayCheckbox[i].value) {
        case "mon": this.setState({ mon: dayCheckbox[i].checked }); break;
        case "tue": this.setState({ tue: dayCheckbox[i].checked }); break;
        case "wed": this.setState({ wed: dayCheckbox[i].checked }); break;
        case "thu": this.setState({ thu: dayCheckbox[i].checked }); break;
        case "fri": this.setState({ fri: dayCheckbox[i].checked }); break;
        case "sat": this.setState({ sat: dayCheckbox[i].checked }); break;
        case "sun": this.setState({ sun: dayCheckbox[i].checked }); break;
        default: break;
      }
    }
  };

  handleActiveRadio = (hour) => {
    this.setState({ hours: hour });
    let input = document.getElementsByClassName("timePeriod");
    input[0].style.pointerEvents = input[1].style.pointerEvents = hour == 1 ? "none" : "auto";
  };

  handleActiveRadioFromEvent = (e) => {
    this.handleActiveRadio(e.target.value);
  };

  onStartTimeChange = (value) => {
    const timeValue = value.target ? value.target.value : value;
    this.setState({
      defaultStart: timeValue,
      startPeriod: timeValueToUtcMoment(timeValue).format(),
    });
  };

  onEndTimeChange = (value) => {
    const timeValue = value.target ? value.target.value : value;
    this.setState({
      defaultEnd: timeValue,
      endPeriod: timeValueToUtcMoment(timeValue).format(),
    });
  };

  handleEmail = () => {
    let email = document.getElementById("emailBox");
    if (email.checked) {
      this.setState({ email: true });
    } else {
      this.setState({ email: false });
    }
  };

  handleStatus = (e) => {
    this.setState({ status: e.target.value });
  };

  handleCheckbox = (e, id, checkedList) => {
    if (!checkedList.includes(id)) {
      checkedList.push(id);
    } else {
      const index = checkedList.indexOf(id);
      checkedList.splice(index, 1);
    }
    this.forceUpdate();
  };

  handleAssetsCheckBox = (e, assetid) => {
    if (!this.checkedAssets.includes(assetid)) {
      this.checkedAssets.push(assetid);
    } else {
      const index = this.checkedAssets.indexOf(assetid);
      this.checkedAssets.splice(index, 1);
    }
    this.forceUpdate();
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.SearchString = this.searchText;
    data.customerId = this.customerId;
    data.PageSize = this.pageSize;
    data.PageNumber = this.pageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;

    return data;
  };

  handlePagination = (page) => {
    this.pageKey = page;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    this.setState({ filterMessage: inputSearch != "" });

    this.searchText = inputSearch;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Notification/AssetsByGroupId/${this.groupId}?${query}`;
    if (this.state.groupId != "") {
      this.postAssets(urlAll);
    }
  };

  handleAutoGroupDropDown = async (groupId, groupName, gcustomerName) => {
    this.setState({
      groupId: groupId,
      groupName: groupName,
      groupCustomerName: gcustomerName,
    });

    this.groupId = groupId;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let url = `${apiHost}/api/Notification/AssetsByGroupId/${groupId}?${query}`;
    this.postAssets(url);
  };

  handleGroupDropDown = async (groupId, groupName, gcustomerName) => {
    this.checkedAssets = [];

    this.setState({
      groupId: groupId,
      groupName: groupName,
      groupCustomerName: gcustomerName,
    });

    this.groupId = groupId;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let url = `${apiHost}/api/Notification/AssetsByGroupIdForNotification/${groupId}?${query}`;
    this.postAssets(url);
  };

  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);

    try {
      const assetList = await axios.get(
        url,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        assetList: assetList.data.paggedlist,
        pageCount: JSON.parse(assetList.headers.pagination).totalPages,
      });
      this.handleShowResults(assetList);
      this.completeAssetList = assetList.data.includedelements;
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

  };
  handleShowResults = (response) => {
    // function for showing entries and total entries in page

    this.setState({
      totalEntry: JSON.parse(response.headers.pagination).totalItems,
    });

    if (!this.state.totalFilter) {
      this.setState({
        totalEntryFilter: JSON.parse(response.headers.pagination).totalItems,
        totalFilter: true,
      });
    }

    this.setState({
      entryStart: (parseInt(this.pageKey) - 1) * parseInt(this.pageSize) + 1,
    });

    if (JSON.parse(response.headers.pagination).totalItems < parseInt(this.state.entryEnd)) {
      this.setState({ entryEnd: JSON.parse(response.headers.pagination).totalItems });
    } else {
      this.setState({ entryEnd: parseInt(JSON.parse(response.headers.pagination).currentPage) * parseInt(this.pageSize) });
    }

    if (this.state.entryEnd > parseInt(JSON.parse(response.headers.pagination).totalItems)) {
      this.setState({ entryEnd: JSON.parse(response.headers.pagination).totalItems });
    }

    if (this.state.assetList == "") {
      this.setState({ entryStart: "0", entryEnd: "0", totalEntry: "0" });
    }
  };

  handleSelectAll = () => {
    this.checkedAssets = this.completeAssetList;
    let query = encodeQueryData(this.setAssetsQueryObject());

    let url = `${apiHost}/api/Notification/AssetsByGroupId/${this.state.groupId}?${query}`;
    this.postAssets(url);
  };

  handleDeselectAll = () => {
    this.checkedAssets = [];
    let query = encodeQueryData(this.setAssetsQueryObject());
    let url = `${apiHost}/api/Notification/AssetsByGroupId/${this.state.groupId}?${query}`;
    this.postAssets(url);
  };

  handleTempANotification = (evt) => {
    this.setState({ tempANotification: evt.target.value == "ON" });
  };
  handleTempBNotification = (evt) => {
    this.setState({ tempBNotification: evt.target.value == "ON" });
  };
  render() {
    const AssetsToggle = React.forwardRef(({ children, onClick }, ref) => (
      <button
        className="long-button-button"
        href=""
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        {children}

        <i className="fa fa-th" />
      </button>
    ));

    // forwardRef again here!
    // Dropdown needs access to the DOM of the Menu to measure it
    const CustomMenu = React.forwardRef(
      ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
        const [value, setValue] = useState("");

        return (
          <div
            ref={ref}
            style={style}
            className={className}
            aria-labelledby={labeledBy}
          >
            <FormControl
              autoFocus
              className="mx-3 my-2 w-auto"
              placeholder="Type to filter..."
              onChange={(e) => setValue(e.target.value)}
              value={value}
              autoComplete="off"
            />
            <ul className="list-unstyled">
              {React.Children.toArray(children).filter(
                (child) =>
                  !value || child.props.children.toLowerCase().includes(value)
              )}
            </ul>
          </div>
        );
      }
    );

    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Notification </title>
          </Helmet>
          <div className="contentBody notification-page-shell">
            <div className="contentWrapper notification-editor-page">
              <div className="notification-page-header notification-editor-header">
                <div>
                  <p className="notification-record-kicker">Notification editor</p>
                  <h2>{this.state.name || "Edit Notification"}</h2>
                  <div className="notification-record-subtitle">
                    <span className="notification-record-badge notification-record-badge-reference">
                      {this.state.uniqueId ? `Notification #${this.state.uniqueId}` : "Notification #"}
                    </span>
                    <span
                      className={`notification-record-badge ${
                        this.state.status == "1"
                          ? "notification-record-badge-active"
                          : "notification-record-badge-disabled"
                      }`}
                    >
                      {this.state.status == "1" ? "Active" : "Disabled"}
                    </span>
                    {this.state.email && (
                      <span className="notification-record-badge notification-record-badge-email">
                        Email
                      </span>
                    )}
                    {this.state.customerName && (
                      <span className="notification-record-badge notification-record-badge-customer">
                        {this.state.customerName}
                      </span>
                    )}
                  </div>
                </div>
                <div className="notification-editor-header-actions">
                  <Button
                    variant="light"
                    onClick={() => {
                      this.props.history.goBack();
                    }}
                  >
                    Back to List
                  </Button>
                  <Button variant="primary" onClick={this.handleSubmit}>
                    Save Changes
                  </Button>
                </div>
              </div>
              <div className="long-dropdown">
                <Form className="notification-editor-form">
                  <section className="notification-editor-tile notification-details-tile">
                    <div className="notification-editor-tile-title">
                      <h3>Notification Details</h3>
                      <p>Identity, owner and description for this notification rule.</p>
                    </div>
                  {localStorage.getItem("role") == "SystemAdmin" && (
                    <Form.Group as={Row} controlId="formHorizontalEmail">
                      <Form.Label column sm={2}>
                        <span className="inline-input"> User</span>
                      </Form.Label>
                      <Col sm={10} className="notification-detail-field">
                        <Form.Control
                          type="text"
                          value={`${this.state.userName}-${this.state.customerName}`}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  )}

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Name</span>
                    </Form.Label>
                    <Col sm={10} className="notification-detail-field">
                      <Form.Control
                        type="text"
                        placeholder="That identifies this notification"
                        onChange={this.handleNameChange}
                        value={this.state.name}
                      />
                      <p
                        style={
                          this.state.name_error
                            ? { color: "#a94442", fontSize: "14px" }
                            : { display: "none" }
                        }
                      >
                        The Name field is required.
                      </p>
                    </Col>
                  </Form.Group>

                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Description</span>
                    </Form.Label>
                    <Col sm={10} className="notification-detail-field">
                      <Form.Control
                        as="textarea"
                        value={this.state.description}
                        placeholder="Optional short description that describes this notification"
                        onChange={this.handleDescriptionChange}
                      />
                    </Col>
                  </Form.Group>
                  </section>

                  <section className="notification-editor-tile">
                    <div className="notification-editor-tile-title">
                      <h3>Schedule</h3>
                      <p>Choose the days and hours when this notification can trigger.</p>
                    </div>
                  <Form.Group className="notification-schedule-field" as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Active Days</span>
                    </Form.Label>

                    <Col sm={10}>
                      <div className="notification-day-grid">
                        <label className={this.state.mon ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="mon"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.mon}
                          />
                          Monday
                        </label>
                        <label className={this.state.tue ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="tue"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.tue}
                          />
                          Tuesday
                        </label>
                        <label className={this.state.wed ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="wed"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.wed}
                          />
                          Wednesday
                        </label>
                        <label className={this.state.thu ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="thu"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.thu}
                          />
                          Thursday
                        </label>
                        <label className={this.state.fri ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="fri"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.fri}
                          />
                          Friday
                        </label>
                        <label className={this.state.sat ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="sat"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.sat}
                          />
                          Saturday
                        </label>
                        <label className={this.state.sun ? "selected" : ""}>
                          <input
                            type="checkbox"
                            className="day"
                            value="sun"
                            onChange={this.handleDayCheckBox}
                            checked={this.state.sun}
                          />
                          Sunday
                        </label>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group className="notification-schedule-field" as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Active Hours</span>
                    </Form.Label>
                    <Col sm={10}>
                      <div className="notification-hour-options">
                        <label className={this.state.hours == 1 ? "selected" : ""}>
                          <input
                            type="radio"
                            name="period"
                            value="1"
                            className="hours"
                            onChange={this.handleActiveRadioFromEvent}
                            checked={this.state.hours == 1 ? true : false}
                          />
                          <span>All day (24 hrs)</span>
                        </label>
                        <label className={this.state.hours == 2 ? "selected" : ""}>
                        <input
                          type="radio"
                          name="period"
                          value="2"
                          className="hours"
                          onChange={this.handleActiveRadioFromEvent}
                          checked={this.state.hours == 2 ? true : false}
                        />
                          <span>Within the specified period</span>
                        </label>
                        <label className={this.state.hours == 3 ? "selected" : ""}>
                        <input
                          type="radio"
                          name="period"
                          value="3"
                          className="hours"
                          onChange={this.handleActiveRadioFromEvent}
                          checked={this.state.hours == 3 ? true : false}
                        />
                          <span>Outside the specified period</span>
                        </label>
                      </div>
                    </Col>
                  </Form.Group>
                  <Form.Group className="notification-schedule-field" as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input">Specific period</span>
                    </Form.Label>
                    <Col sm={10}>
                      <div className="notification-period-grid">
                        <div>
                          <span>From</span>
                            <div className="timePeriod">
                              <span className="fa fa-clock-o" />
                              {this.state.defaultStart != "" && (
                                <input
                                  type="time"
                                  value={this.state.defaultStart}
                                  className="timePicker"
                                  onChange={this.onStartTimeChange}
                                />
                              )}
                            </div>
                        </div>
                        <div>
                          <span>Until</span>
                            <div className="timePeriod">
                              <span className="fa fa-clock-o" />
                              {this.state.defaultStart != "" && (
                                <input
                                  type="time"
                                  value={this.state.defaultEnd}
                                  className="timePicker"
                                  onChange={this.onEndTimeChange}
                                />
                              )}
                            </div>
                        </div>
                      </div>
                      <p className="desc">
                        Defines the time period for each day. Within notifies inside the From and Until period. Outside notifies outside it.
                      </p>
                    </Col>
                  </Form.Group>
                  </section>

                  <section className="notification-editor-tile notification-delivery-tile">
                    <div className="notification-editor-tile-title">
                      <h3>Delivery</h3>
                      <p>Email delivery and active status for this notification.</p>
                    </div>
                    <div className="notification-delivery-grid">
                      <Form.Group controlId="formPlainTimeZone">
                        <Form.Label>
                          <span className="inline-input">Status</span>
                        </Form.Label>
                        <Form.Control
                          as="select"
                          value={this.state.status}
                          onChange={this.handleStatus}
                        >
                          {console.log("statuis not", this.state.status)}

                          <option value="1">Active</option>
                          <option value="0">Disable</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group controlId="formHorizontalEmail">
                        <Form.Label>
                          <span className="inline-input">Options</span>
                        </Form.Label>
                        <label className={`notification-checkbox-option ${this.state.email ? "selected" : ""}`}>
                            <input
                              type="checkbox"
                              id="emailBox"
                              onChange={this.handleEmail}
                              checked={this.state.email}
                            />
                            Receive email
                        </label>
                      </Form.Group>
                    </div>
                  </section>

                  <section className="notification-editor-tile">
                    <div className="notification-editor-tile-title">
                      <h3>Events</h3>
                      <p>Select the event types that should trigger this notification.</p>
                    </div>
                  <Form.Group as={Row} controlId="formPlainTimeZone">
                    <Form.Label column sm="2">
                      <span className="inline-input">Events</span>
                    </Form.Label>
                    <Col sm="10">
                      <Table className="notification-selection-table" responsive>
                        <thead>
                          <tr>
                            <th></th>
                            <th>Name</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.eventList.map((event, index) => {
                            return (
                              <tr
                                key={index}
                                className={this.checkedEvents.includes(event.id) ? "selected" : ""}
                                value={event.id}
                                id={`tr-${event.id}`}
                                onClick={(e) => this.handleCheckbox(e, event.id, this.checkedEvents)}
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    value={event.id}
                                    className="tr-eventCheckBox"
                                    id={event.id}
                                    style={{ pointerEvents: "none" }}
                                    checked={this.checkedEvents.includes(event.id)}
                                    readOnly
                                  />
                                </td>
                                <td>{event.name}</td>
                                <td>{event.description}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </Col>
                  </Form.Group>
                  </section>

                  <section className="notification-editor-tile">
                    <div className="notification-editor-tile-title">
                      <h3>Assets</h3>
                      <p>Choose the asset group and individual assets covered by this notification.</p>
                    </div>
                  <Form.Group as={Row} controlId="formHorizontalEmail">
                    <Form.Label column sm={2}>
                      <span className="inline-input"> Assets</span>
                    </Form.Label>
                    <Col sm={10}>
                      <Dropdown>
                        <Dropdown.Toggle
                          as={AssetsToggle}
                          style={{ width: "100px" }}
                          value={this.state.groupId}
                          id="dropdown-custom-components"
                        >
                          {localStorage.getItem("role") == "SystemAdmin" && this.state.groupCustomerName != ""
                            ? `${this.state.groupCustomerName} - ${this.state.groupName}`
                            : this.state.groupName}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          as={CustomMenu}
                          value={this.state.groupId}
                        >
                          {this.state.groupList.map((item, index) => {
                            return (
                              <Dropdown.Item
                                value={item.groupId}
                                className={
                                  this.state.groupId == `${item.groupId}`
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  this.handleGroupDropDown(
                                    item.groupId,
                                    item.groupName,
                                    item.customername
                                  );
                                }}
                              >
                                {localStorage.getItem("role") == "SystemAdmin"
                                  ? `${item.customername} - ${item.groupName}`
                                  : item.groupName}
                              </Dropdown.Item>
                            );
                          })}
                        </Dropdown.Menu>
                      </Dropdown>
                      <div className="assettable">
                        <div className="notification-asset-toolbar">
                          <div>
                            <input
                              type="button"
                              onClick={this.handleSelectAll}
                              value="Select all"
                            ></input>
                            &nbsp;
                            <input
                              type="button"
                              onClick={this.handleDeselectAll}
                              value="Select none"
                            ></input>
                            &nbsp;
                          </div>

                          <Search searchCallback={this.handleSearch}></Search>
                        </div>
                        <Table className="notification-selection-table" responsive>
                          <thead>
                            <tr>
                              <th></th>
                              <th>
                                Name{" "}
                                {this.state.sortString == "name" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("name");
                                    }}
                                  />
                                )}
                              </th>
                              <th>Description</th>
                              <th>
                                Profile{" "}
                                {this.state.sortString == "profile" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("profile");
                                    }}
                                  />
                                )}
                              </th>
                              <th>Status</th>
                              <th>
                                Updated{" "}
                                {this.state.sortString == "updated" ? (
                                  <i
                                    onClick={this.handleSortDirection}
                                    className={`fa ${this.state.sortDirection == "asc"
                                      ? "fa-sort-amount-asc"
                                      : "fa-sort-amount-desc"
                                      }`}
                                  />
                                ) : (
                                  <i
                                    className="fa fa-exchange"
                                    onClick={() => {
                                      this.handleSortString("updated");
                                    }}
                                  />
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.assetList == "" ? (
                              <tr>
                                <td colSpan="6" style={{ textAlign: "center" }}>
                                  "No data available in table"
                                </td>
                              </tr>
                            ) : (
                              this.state.assetList.map((item, index) => {
                                return (
                                  <tr
                                    key={index}
                                    className={this.checkedAssets.includes(item.assetId) ? "selected" : ""}
                                    id={`tr-${item.assetId}`}
                                    onClick={(e) => this.handleCheckbox(e, item.assetId, this.checkedAssets)}
                                  >
                                    <td>
                                      <input
                                        className="tr-checkBox"
                                        value={item.assetId}
                                        type="checkbox"
                                        id={item.assetId}
                                        style={{ pointerEvents: "none" }}
                                        checked={this.checkedAssets.includes(item.assetId)}
                                        readOnly
                                      />
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{item.description}</td>
                                    <td>{item.profile}</td>
                                    <td>{item.status}</td>
                                    <td>{utcToLocal(item.dbUpdated)}</td>
                                  </tr>
                                );
                              })
                            )}
                          </tbody>
                        </Table>
                        <div className="notification-editor-pagination">
                          <ShowingResults
                            currentEntryStart={this.state.entryStart}
                            currentEntryEnd={this.state.entryEnd}
                            totalEntries={this.state.totalEntry}
                            totalFilterEntries={this.state.totalEntryFilter}
                            filterMessage={this.state.filterMessage}
                          />
                          <Paginations
                            onPagination={this.handlePagination}
                            pageCount={this.state.pageCount}
                            pageRange={5}
                          ></Paginations>
                        </div>
                      </div>
                    </Col>
                  </Form.Group>
                  </section>
                </Form>
              </div>
              <div className="notification-edit-meta">
                <div>
                  <span>Created</span>
                  <strong>
                    {this.state.NotificationDetail.dbCreated
                      ? utcToLocal(this.state.NotificationDetail.dbCreated)
                      : "Not created"}
                  </strong>
                </div>
                <div>
                  <span>Updated</span>
                  <strong>
                    {this.state.NotificationDetail.dbUpdated
                      ? utcToLocal(this.state.NotificationDetail.dbUpdated)
                      : "Not updated"}
                  </strong>
                </div>
              </div>
              <div className="footer-menu notification-editor-actions">
                <Button
                  variant="outline-secondary"
                  onClick={() => {
                    //this.props.history.push("/notifications");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button variant="primary" onClick={this.handleSubmit}>
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditNotification);
